<app-search-filter-bar
  (navigateBack)="back()"
  (toggleFilterEvent)="showFilterInterface.set(!showFilterInterface())"
  #searchBar
></app-search-filter-bar>
<ng-container *ngIf="!this.showFilterInterface(); else filterView">
  <div *ngIf="workplaceService.vm$ | async as view" class="mt-4">
    <!-- Production Line Layer -->
    <div
      *ngIf="view.showProductionLines && !view.selectedLineId"
      class="d-flex flex-wrap row-gap-2 col-gap-2"
    >
      <div *ngFor="let line of view.productionLines" class="w-50 h-100">
        <app-workplace-card
          class="h-100"
          [workplace]="line"
          [displayProperties]="['escalatedReports']"
          (click)="selectProductionLine(line)"
        ></app-workplace-card>
      </div>
    </div>

    <!-- Workplaces Layer -->
    <div *ngIf="view.selectedLineId">
      <div class="d-flex flex-wrap row-gap-2 col-gap-2">
        <app-workplace-card
          class="w-50 h-100"
          *ngFor="let workplace of view.workplaces"
          [workplace]="workplace"
          [displayProperties]="['escalatedReports']"
          (click)="selectWorkplace(workplace.id!)"
        ></app-workplace-card>
      </div>
    </div>
  </div>
</ng-container>
<ng-template #filterView>
  <div class="workplace-details d-flex flex-row gap-2 flex-start mt-4">
    <div class="report-section w-50">
      <div class="heading mx-2 d-flex justify-content-between">
        {{
          workplaceService.selectedProductionLineSignal()?.name
            ? workplaceService.selectedProductionLineSignal()?.name
            : "Gesamtübersicht"
        }}
        <i class="bi bi-chevron-right"></i>
      </div>
      <div class="workplace-report-container d-flex">
        <div class="report-section col-7">
          <div class="mx-2 py-2">
            <div>
              <div
                class="active-report-container"
                *ngIf="activeReports(); else noReports"
              >
                <app-report-table
                  [dataSource]="activeReports()!"
                  [tableHeading]="'Aktive Stillstandsmeldungen'"
                  [displayedColumns]="displayedColumns"
                  [tableWidth]="'w-100'"
                ></app-report-table>
              </div>
              <div class="report-container mt-5" *ngIf="solvedReports()">
                <app-report-table
                  [dataSource]="solvedReports()!"
                  [tableHeading]="'Stillstandsmeldungen'"
                  [displayedColumns]="displayedColumns"
                  [tableWidth]="'w-100'"
                ></app-report-table>
              </div>
            </div>
            <ng-template #noReports>
              <p>Keine Stillstandsmeldungen</p>
            </ng-template>
          </div>

          <app-paginator
            [totalPages]="totalPages()"
            (pageChange)="this.setPage($event)"
          ></app-paginator>
        </div>
      </div>
    </div>
    <div class="filter-section w-50" *ngIf="showFilterInterface()">
      <app-filter-interface
        #reportFilter
        (closeFilterInterface)="showFilterInterface.set(!showFilterInterface())"
        (filterValueChange)="onFilterValueChange($event)"
      ></app-filter-interface>
    </div>
  </div>
</ng-template>
